import { connect } from "react-redux";
import get from "lodash/get";

import {
  getIntegraionTypes as onGetIntegraionTypes,
  getIntegraions as onGetIntegraions,
  createIntegraions as onCreateIntegraions,
  deleteIntegraions as onDeleteIntegraions,
} from "../../actions/integrationsActions";

const mapStateToProps = (state) => ({
  integrationsDataState: state.integrations.integrationsDataState,
  integrationTypesDataState: state.integrations.integrationTypesDataState,
  integrationCreateDataState: state.integrations.integrationCreateDataState,
  integrationDeleteDataState: state.integrations.integrationDeleteDataState,
  integrations: get(state, ["integrations", "integrations"], []),
  integrationTypes: get(state, ["integrations", "integrationTypes"], []),
  errors: get(state, ["integrations", "errors"], null),
});

const mapDispatchToProps = { onGetIntegraionTypes, onGetIntegraions, onCreateIntegraions, onDeleteIntegraions };

const withIntegrations = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withIntegrations };
